module.exports = __webpack_public_path__ + "static/media/portfoliopic.b12a0463.jpg";